module.exports = __webpack_public_path__ + "img/icon-aro.296aa7a0.svg";